// extracted by mini-css-extract-plugin
module.exports = {"stepButtons":"Index_stepButtons__1KS4P","title":"Index_title__3hO2z"};